// V2.15.9 — Sentry init helper. Silent no-op when REACT_APP_SENTRY_DSN is
// absent (preview without observability), fully active in prod when the DSN
// env var is populated by the Emergent prod environment.
import * as Sentry from "@sentry/react";

let _initialized = false;

export function initSentry() {
  const dsn = (process.env.REACT_APP_SENTRY_DSN || "").trim();
  if (!dsn || _initialized) return false;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || "development",
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    release: process.env.REACT_APP_RELEASE || `solarsim@${process.env.REACT_APP_VERSION || "2.15.9"}`,
    beforeSend(event) {
      // Scrub PII before shipping to Sentry.
      if (event.user?.email) delete event.user.email;
      if (event.user?.username) delete event.user.username;
      if (event.request?.data) {
        try {
          const scrubbed = JSON.parse(JSON.stringify(event.request.data));
          const walk = (o) => {
            if (!o || typeof o !== "object") return;
            for (const k of Object.keys(o)) {
              if (/email|phone|password|token/i.test(k)) o[k] = "[redacted]";
              else if (typeof o[k] === "object") walk(o[k]);
            }
          };
          walk(scrubbed);
          event.request.data = scrubbed;
        } catch {
          /* keep original if structured clone fails */
        }
      }
      return event;
    },
  });

  // Expose a lean hook for the Simulator ErrorBoundary (and anything else
  // that wants to pipe custom errors in without importing Sentry directly).
  if (typeof window !== "undefined") {
    window.__onSimulatorError = ({ error, info } = {}) => {
      Sentry.captureException(error, {
        tags: { component: "simulator" },
        extra: info ? { componentStack: info.componentStack } : undefined,
      });
    };
  }

  _initialized = true;
  // eslint-disable-next-line no-console
  console.info("[Sentry] initialized");
  return true;
}

export { Sentry };
